module.exports = __webpack_public_path__ + "img/train_icon.e0e57bc2.png";